import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2" }
const _hoisted_2 = { class: "flex w-full flex-col gap-1.5 pt-1" }

import { Skeleton } from '@/components/ui/skeleton';

export default /*@__PURE__*/_defineComponent({
  __name: 'CommentsSkeleton',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Skeleton), { class: "size-6 rounded-full" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(Skeleton), { class: "h-4 w-full" }),
      _createVNode(_unref(Skeleton), { class: "h-4 w-full" })
    ])
  ]))
}
}

})